<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-indent:00em; padding-top:120px;">After years of being told to write down my sardonic musings, I finally took the plunge. These poems explore the various thoughts that I, and others, have had at various points in life and are easily read and accessible for all.</p><br/>
<p style="text-indent:00em;">When I began writing, I noticed that poetry that rhymed appeared to be a bit of an enigma these days, so I have specifically created rhyming poems that take the reader on a journey. That journey can be happy, sad, comedic, tragic, or whimsical, but it’s certainly a journey, and I hope you, yes you, enjoy reading them.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?69093283